import { createApiClient } from '@bandmate/api-client';

const API_BASE = '/api';

export const api = createApiClient({
  baseURL: API_BASE,
  getToken: () => localStorage.getItem('accessToken'),
  setToken: (token) => localStorage.setItem('accessToken', token),
  clearToken: () => localStorage.removeItem('accessToken'),
  onUnauthorized: () => {
    const publicPaths = ['/login', '/shared/', '/accept-invite', '/api/public/'];
    const isPublicPath = publicPaths.some((path) => window.location.pathname.startsWith(path));
    if (!isPublicPath) {
      window.location.href = '/login';
    }
  }
});

export default api;
